"use client"
import React, { useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { useAppData } from "@/lib/providers/AppDataProvider";
import "@/components/locator/LocatorSearchFilters.css";

const BusinessProfileFilters = ({
  onFilterChange,
  searchResults,
  // false hides the "Open Now" toggle and leaves the filter off
  showOpenNow = true
}) => {
  const { amenities } = useAppData();

  const [amenityOptions, setAmenityOptions] = useState(null);

  const [selectedAmenities, setSelectedAmenities] = useState([]);
  const [openNow, setOpenNow] = useState(showOpenNow);

  useEffect(() => {
    // todo set amenity options if either one of these changes
    if (amenities && searchResults && searchResults.length > 0) {
      // Get all amenities that appear in search results
      const amenitiesInResults = new Set();
      searchResults.forEach(result => {
        if (result.amenities) {
          result.amenities.forEach(amenity => {
            amenitiesInResults.add(amenity);
          });
        }
      });

      // Filter amenities to only include those that appear in search results
      const filteredAmenities = amenities.filter(amenity =>
        amenitiesInResults.has(amenity.value)
      );

      setAmenityOptions(filteredAmenities);
    }
  }, [amenities, searchResults]);

  useEffect(() => {
    onFilterChange(selectedAmenities, openNow);
  }, [selectedAmenities, openNow]);

  // the category picker lives in LocatorCategoryPanel; these filters only apply to search results
  if (searchResults == null || searchResults.length === 0) return null;

  return (
    <div className="search-filters">
      <div className="default-flex-row-layout">
        {showOpenNow && (
          <div
            style={{ width: "8rem" }}
            className={`btn btn-sm btn-secondary with-icon${
              openNow ? " active" : ""
            }`}
            onClick={() => setOpenNow(!openNow)}
          >
            <i className="fa-solid fa-clock"></i>
            <span>Open Now</span>
          </div>
        )}
        {amenityOptions && amenityOptions.length > 0 && (
          <Dropdown onSelect={val => setSelectedAmenities([val])}>
            <Dropdown.Toggle
              variant="secondary"
              className="btn btn-sm btn-secondary"
              style={{ width: "8rem" }}
            >
              Amenities
              <div className="flex-grow" />
            </Dropdown.Toggle>
            <Dropdown.Menu
              renderOnMount={true}
              popperConfig={{ strategy: "fixed" }}
            >
              {amenityOptions.map(amenity => (
                <Dropdown.Item
                  className="with-icon"
                  id={`amenity-${amenity.value}`}
                  key={`amenity-${amenity.value}`}
                  eventKey={amenity.value}
                >
                  <i className={`fa-solid ${amenity.icon}`}></i>
                  {amenity.label}
                </Dropdown.Item>
              ))}
            </Dropdown.Menu>
          </Dropdown>
        )}
      </div>
    </div>
  );
};

export default BusinessProfileFilters;
